import { ThemeProperties } from '../../../core';

export interface TableColumnMenuTheme {
	contentBackground: string;
	contentBorderColor: string;
	contentBorderRadius: string;
	contentBoxShadow: string;

	itemFont: string;
	itemFontColor: string;
	itemHoverBackground: string;

	gripIconColor: string;

	focusRingColor: string;
}

export const theme = new ThemeProperties('tableColumnMenu');
